import React from 'react';
import { Field, TextInput, TextArea, RadioPair } from '../lib/FormControls';
import { TERM_INSURANCE_TYPE } from '../lib/fieldDefs';

const NONE_TOOLTIP = 'Type NONE if this does not apply to you.';

export default function Step7HealthPrimary({ form, setField }) {
  const isTerm = form.insurance_type === TERM_INSURANCE_TYPE;

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold text-gray-900">Health Questionnaire (Primary Insured)</h2>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <Field label="Health Provider" required>
          <TextArea
            rows={3}
            value={form.health_provider}
            onChange={(e) => setField('health_provider', e.target.value)}
          />
        </Field>
        <Field label="Last Medical Visit" required>
          <TextInput
            value={form.last_medical_visit}
            onChange={(e) => setField('last_medical_visit', e.target.value)}
          />
        </Field>
        <Field label="Height" required>
          <TextInput value={form.height} onChange={(e) => setField('height', e.target.value)} />
        </Field>
        <Field label="Weight" required>
          <TextInput value={form.weight} onChange={(e) => setField('weight', e.target.value)} />
        </Field>
        <Field label="Weight Change 10lbs">
          <RadioPair
            value={form.weight_change_10lbs}
            onChange={(v) => setField('weight_change_10lbs', v)}
          />
        </Field>
        <Field label="Is Smoker" required>
          <RadioPair value={form.is_smoker} onChange={(v) => setField('is_smoker', v)} />
        </Field>
        <Field label="Other Specialists 5yr">
          <RadioPair
            value={form.other_specialists_5yr}
            onChange={(v) => setField('other_specialists_5yr', v)}
          />
        </Field>
        <Field label="International Travel">
          <RadioPair
            value={form.international_travel}
            onChange={(v) => setField('international_travel', v)}
          />
        </Field>
        <Field label="Dangerous Activities">
          <RadioPair
            value={form.dangerous_activities}
            onChange={(v) => setField('dangerous_activities', v)}
          />
        </Field>
        <Field label="Unpaid Tickets">
          <RadioPair value={form.unpaid_tickets} onChange={(v) => setField('unpaid_tickets', v)} />
        </Field>
        <Field label="Exercises Regularly">
          <RadioPair
            value={form.exercises_regularly}
            onChange={(v) => setField('exercises_regularly', v)}
          />
        </Field>
      </div>
      <Field label="Medications (Last 5 Years)" required tooltip={NONE_TOOLTIP}>
        <TextArea
          rows={3}
          value={form.medications_5yr}
          onChange={(e) => setField('medications_5yr', e.target.value)}
        />
      </Field>
      {form.other_specialists_5yr === 'Yes' && (
        <Field label="Other Specialists Detail">
          <TextArea
            rows={3}
            value={form.other_specialists_detail}
            onChange={(e) => setField('other_specialists_detail', e.target.value)}
          />
        </Field>
      )}
      <Field label="Father Details" required={isTerm}>
        <TextArea
          rows={3}
          value={form.father_details}
          onChange={(e) => setField('father_details', e.target.value)}
        />
      </Field>
      <Field label="Mother Details" required={isTerm}>
        <TextArea
          rows={3}
          value={form.mother_details}
          onChange={(e) => setField('mother_details', e.target.value)}
        />
      </Field>
      <Field label="Siblings Details" required={isTerm}>
        <TextArea
          rows={3}
          value={form.siblings_details}
          onChange={(e) => setField('siblings_details', e.target.value)}
        />
      </Field>
      <Field label="Health Conditions" required tooltip={NONE_TOOLTIP}>
        <TextArea
          rows={3}
          value={form.health_conditions}
          onChange={(e) => setField('health_conditions', e.target.value)}
        />
      </Field>
    </div>
  );
}
